import { createSlice } from "@reduxjs/toolkit";

const data = {
    listCargo: [{ id: 0, descripcion: "" }],
    listEstadoLaboral: [{ id: 0, descripcion: "" }],
    entity: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idRepresentante: 0,
        idCargo: 0,
        cargo: "",
        idEstadoLaboral: 0,
        estadoLaboral: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
    validationActive: {
    },
    validationMessage: [],
}

export const personRepresentativeSlice = createSlice({
    name: "personRepresentative",
    initialState: {},
    reducers: {
        init: (state, action) => {
            const { sliceKey } = action.payload;
            if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
        },
        setListCargo: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].listCargo = data;
        },
        setListEstadoLaboral: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].listEstadoLaboral = data;
        },
        setEntity: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].entity = data;
        },
        setValue: (state, action) => {
            var { sliceKey, numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state[sliceKey].entity.findIndex(item => item.numero === numero);
            state[sliceKey].entity[index][name] = value;
        },
        add: (state, action) => {
            var sliceKey = action.payload;
            var maxNumero = state[sliceKey].entity.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].entity.map((item) => { return item.numero; }))

            state[sliceKey].entity.push(defaultEntity.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
        },
        remove: (state, action) => {
            const { sliceKey, numero } = action.payload;
            state[sliceKey].entity = state[sliceKey].entity.filter(item => item.numero !== numero)
        },
      setValidations: (state, action) => {
        const {sliceKey, message} = action.payload;
        if (JSON.stringify(state[sliceKey].validationMessage) !== JSON.stringify(message)) {
            state[sliceKey].validationMessage = message;
        }
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
            state[sliceKey].validationActive[key] = true;
        })
      },
    },
});

export const { init, setEntity, setValue,
    setListCargo, setListEstadoLaboral,
    add, remove, setValidations, activeValidations } = personRepresentativeSlice.actions;
export const defaultEntity = [{
    id: 0,
    idPersona: 0,
    numero: 1,
    idRepresentante: 0,
    idCargo: 0,
    cargo: "",
    idEstadoLaboral: 155,
    estadoLaboral: "Vigente",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}]
export default personRepresentativeSlice.reducer;
